/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationsInternalServerError
 */
export interface NotificationsInternalServerError {
    /**
     * 
     * @type {number}
     * @memberof NotificationsInternalServerError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationsInternalServerError
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsInternalServerError
     */
    message: string;
}

/**
 * Check if a given object implements the NotificationsInternalServerError interface.
 */
export function instanceOfNotificationsInternalServerError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function NotificationsInternalServerErrorFromJSON(json: any): NotificationsInternalServerError {
    return NotificationsInternalServerErrorFromJSONTyped(json, false);
}

export function NotificationsInternalServerErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsInternalServerError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': json['message'],
    };
}

export function NotificationsInternalServerErrorToJSON(value?: NotificationsInternalServerError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': value.message,
    };
}

